/**
 * KB-4281 — the fields the program form CLEARS when a person picks a price state or a tier count. The form's
 * handlers (`applyProgramPriceState`, PricingFields' tiered-pricing checkbox and tier-count select) apply
 * these, and so does the operator CLI (`scripts/camp-data/_operator/shared-program.cjs`), so a program saved
 * either way carries no price the form would have wiped.
 *
 * `fields` are top-level values to set; `alternativeFields` are nulled on every
 * `regularOfferIncrementAlternatives[]` entry.
 */
export type PricingClears = {
  fields: Record<string, unknown>;
  alternativeFields: string[];
};

const NONE: PricingClears = { fields: {}, alternativeFields: [] };

/** Choosing Free or Price unknown clears every price the program carries; Priced (null) clears nothing. */
export function priceStateClears(next: "free" | "unknown" | null): PricingClears {
  if (next === null) return NONE;
  return {
    fields: {
      priceRegular: null,
      priceRegularTier2: null,
      priceRegularTier3: null,
      pricingTiers: null,
      regularOfferIncrementAlternatives: [],
    },
    alternativeFields: [],
  };
}

/** Unticking tiered pricing (0) clears both member tiers; choosing 2 tiers clears tier 3; 3 clears nothing. */
export function tierCountClears(numTiers: 0 | 2 | 3): PricingClears {
  if (numTiers === 0) {
    return { fields: { priceRegularTier2: null, priceRegularTier3: null }, alternativeFields: ["priceTier2", "priceTier3"] };
  }
  if (numTiers === 2) return { fields: { priceRegularTier3: null }, alternativeFields: ["priceTier3"] };
  return NONE;
}
